module.exports = __webpack_public_path__ + "img/file-img-xls.1a36a1f4.jpg";